import React from 'react';
import { observer } from 'mobx-react';
import appState from "../../state/AppState";
import { withApollo } from "react-apollo";
import withTranslate from "../../translator/withTranslate";
import withRouter from "react-router-dom/es/withRouter";
import Select2Component from "../../components/fields/Select2Component"
import PropsUtil from "../../util/PropsUtil";
import AppLogger from "../../util/AppLogger";
import FiltersPage from "../FiltersPage";
import DateIntervalInputField from "../../components/fields/DateIntervalInputField";

@observer
class OrderListFilters extends FiltersPage {

    nameVariableStateFilter = "orderListFilters";


    initialize() {
        super.initialize();
        //Indica que aunque sea un Date se debe hacer la llamada a GQL como DateTime completo
        //this.log("constructor() this.nameVariableStateFilter:"+this.nameVariableStateFilter);
        //this.log(toJS(appState[this.nameVariableStateFilter]));
        appState[this.nameVariableStateFilter].filterType["createdAt"] = "DateTime";
    }

    render() {
        this.log("OrderListFilters.render()");
        this.propsUtil = new PropsUtil(this.props);

        let { t } = this.props;

        return (
            <React.Fragment>
                <DateIntervalInputField
                    prefix={"fa fa-calendar"}
                    value={appState[this.nameVariableStateFilter].currentFilter.createdAt_From}
                    valueTo={appState[this.nameVariableStateFilter].currentFilter.createdAt_To}
                    onChange={(e) => this.updateInputFilterEvent(e, "GTEQ")}
                    onChangeTo={(e) => this.updateInputFilterEvent(e, "LTEQ")}
                    name={'createdAt_From'}
                    nameTo={'createdAt_To'}
                    title={t("Fecha Creación")}
                    title2={t("Fecha Hasta")}
                    classGroup={"col-8"}
                    type={"text"}
                    info={t("Desde")}
                    info2={t("Hasta")}
                    // errors={errorsMapped.interventionProposedDate}
                />
                <Select2Component
                    value={appState[this.nameVariableStateFilter].currentFilter.createdBy}
                    onChange={(e, op) => this.updateInputFilterEvent(e, op)}
                    name={"createdBy"}
                    title={t("Creado por")}
                    classGroup={"col-4"}
                    options={appState.userCacheState.userCacheForSelectList}
                    //multi={true}
                    //errors={errorsMapped.status}
                />

                <Select2Component
                    value={appState[this.nameVariableStateFilter].currentFilter.status}
                    onChange={(e, op) => this.updateInputFilterEvent(e, op)}
                    name={"status"}
                    operatorFilter={"IN"}
                    optionsWrappedWithCommas={false}
                    title={t("Estado")}
                    classGroup={"col-12"}
                    options={appState.typifiedState.orderStatusForSelect}
                    multi={true}
                    //errors={errorsMapped.status}
                />

                <Select2Component
                    value={appState[this.nameVariableStateFilter].currentFilter.clientId}
                    onChange={(e, op) => this.updateInputFilterEvent(e, op)}
                    name="clientId"
                    title={t("Establecimiento")}
                    operatorFilter={"IN"}
                    classGroup={"col-12"}
                    optionsWrappedWithCommas={false}
                    options={appState.clientCacheState.clientCacheForOrderSelect}
                    multi={true}
                    //errors={errorsMapped.clientName}
                />
            </React.Fragment>
        )
    }

    log(msg) {
        AppLogger.get().debug(msg, this);
    }


}


export default withRouter(withApollo(withTranslate(OrderListFilters, "OrderListFilters")));
